<script>
  import {createEventDispatcher} from 'svelte';
  import Button from '@/widgets/Button.svelte';
  import Modal from '@/widgets/Modal.svelte';

  export let title = '';
  export let message = '';

  const dispatch = createEventDispatcher();

  function handleCloseClick() {
    dispatch('close');
  }
</script>

<style>
  .footer {
    margin: 40px auto 0;
  }
  .mt42 {
    margin-top: 42px;
  }
  .button {
    justify-content: flex-end;
  }
</style>

<Modal visible>
  <div class="lh24 b f16 T2 df jcsb" slot="header">
    <div class="lh24 fw2 f18 T1">{title}</div>
  </div>
  <div class="footer df fdc" slot="footer">
    <div>
      <div class="f14 t2 fw2 lh22">
        {message}
      </div>
      <div class="df button mt42">
        <Button class="ml24" type="primary" size="small" on:click={handleCloseClick}>OK</Button>
      </div>
    </div>
  </div>
</Modal>
